"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ColumnTimezoneUpdateDependencyHandler", {
    enumerable: true,
    get: function() {
        return ColumnTimezoneUpdateDependencyHandler;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _models = require("~/models");
const _cli = require("~/cli");
const _modelUtils = require("~/utils/modelUtils");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
let ColumnTimezoneUpdateDependencyHandler = class ColumnTimezoneUpdateDependencyHandler {
    async getAffectedDependency(context, param, ncMeta = _Noco.default.ncMeta) {
        var _newEntityMeta_display_column_meta, _newEntityMeta_display_column_meta1, _oldEntityMeta_display_column_meta;
        let validForProcess = false;
        const affectedColumnIds = [];
        const newEntityMeta = (0, _nocodbsdk.parseProp)(param.newEntity.meta);
        const oldEntityMeta = (0, _nocodbsdk.parseProp)(param.oldEntity.meta);
        if ([
            _nocodbsdk.UITypes.DateTime,
            _nocodbsdk.UITypes.Date
        ].includes(param.newEntity.uidt) && // we leave it as is if the new meta timezone empty / not set
        newEntityMeta.timezone && newEntityMeta.timezone !== oldEntityMeta.timezone) {
            validForProcess = true;
            affectedColumnIds.push(param.newEntity.id);
        } else if ([
            _nocodbsdk.UITypes.Formula
        ].includes(param.newEntity.uidt) && ((_newEntityMeta_display_column_meta = newEntityMeta.display_column_meta) == null ? void 0 : _newEntityMeta_display_column_meta.timezone) && ((_newEntityMeta_display_column_meta1 = newEntityMeta.display_column_meta) == null ? void 0 : _newEntityMeta_display_column_meta1.timezone) !== ((_oldEntityMeta_display_column_meta = oldEntityMeta.display_column_meta) == null ? void 0 : _oldEntityMeta_display_column_meta.timezone)) {
            validForProcess = true;
            affectedColumnIds.push(param.newEntity.id);
        }
        if (validForProcess) {
            return {
                filters: await ncMeta.metaList2(context.workspace_id, context.base_id, _cli.MetaTable.FILTER_EXP, {
                    xcCondition: (qb)=>qb.whereIn('fk_column_id', affectedColumnIds)
                })
            };
        }
        return undefined;
    }
    async handle(context, param, ncMeta = _Noco.default.ncMeta) {
        var _param_affectedDependencyResult_filters, _parseProp_display_column_meta;
        if (!((_param_affectedDependencyResult_filters = param.affectedDependencyResult.filters) == null ? void 0 : _param_affectedDependencyResult_filters.length)) {
            return;
        }
        let timezone;
        if ([
            _nocodbsdk.UITypes.DateTime,
            _nocodbsdk.UITypes.Date
        ].includes(param.newEntity.uidt) && (0, _nocodbsdk.parseProp)(param.newEntity.meta).timezone) {
            timezone = (0, _nocodbsdk.parseProp)(param.newEntity.meta).timezone;
        } else if ([
            _nocodbsdk.UITypes.Formula
        ].includes(param.newEntity.uidt) && ((_parseProp_display_column_meta = (0, _nocodbsdk.parseProp)(param.newEntity.meta).display_column_meta) == null ? void 0 : _parseProp_display_column_meta.timezone)) {
            var _parseProp_display_column_meta1;
            timezone = (_parseProp_display_column_meta1 = (0, _nocodbsdk.parseProp)(param.newEntity.meta).display_column_meta) == null ? void 0 : _parseProp_display_column_meta1.timezone;
        }
        for (const each of param.affectedDependencyResult.filters){
            each.meta = (0, _modelUtils.parseMetaProp)(each);
            each.meta.timezone = timezone;
            await _models.Filter.update(_extends({}, context, {
                base_id: each.base_id,
                workspace_id: each.fk_workspace_id
            }), each.id, _extends({}, each, {
                meta: (0, _modelUtils.stringifyMetaProp)(each)
            }), ncMeta);
        }
    }
    constructor(){
        this.triggerMetaEvents = [
            _nocodbsdk.MetaEventType.COLUMN_UPDATED
        ];
    }
};
ColumnTimezoneUpdateDependencyHandler = _ts_decorate([
    (0, _common.Injectable)()
], ColumnTimezoneUpdateDependencyHandler);
